<div class="toast-container position-fixed top-0 start-50 translate-middle-x p-3">
  @for (toastItem of toastItemList; track toastItem) {
    <app-toast-item [toastItem]="toastItem" (onClose)="toastRemove(toastItem)"></app-toast-item>
  }
</div>
